var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/library/modules/_core.js